import { first, map } from 'rxjs/operators'
import Router from 'vue-router'

import { ConditionReportState } from '@skinsoft/types'
import { AuthService } from '@skinsoft/auth'
import { Login } from '@skinsoft/auth-ui'
import { ItemEditScreen } from '@skinsoft/entity-ui/src/item/components/item-edit-screen'
import { SoloItemEditScreen } from '@skinsoft/entity-ui/src/item/components/solo-item-edit-screen'
import { ItemEditMenu } from '@skinsoft/entity-ui/src/item/components/item-edit-menu'
import { ActionType } from '@skinsoft/ui'
import { ReportMenu } from './app/component/report-menu'
import { EditReportScreen } from './app/report-edition/edit-report-screen'
import { ReportList } from './app/report-list'
import { ItemSearchScreen } from '../../../lib/@skinsoft/search/src/search-screen/item-search-screen'
import { router as unifiedRouter } from '../../../reporter-launcher/src/router' // TODO better'

declare var UNIFY_ROUTER: boolean

export enum Routes {
    CONDITION_REPORT_HOME = 'conditionReportHome',
    LOGIN = 'login',
    EDIT_REPORT = 'edit_report',
    CLOSE_REPORTS = 'close-reports',
    CURRENT_REPORTS = 'current-rerports',
    ITEM = 'item',
}

const routes = [
    {
        component: ItemSearchScreen,
        name: Routes.CONDITION_REPORT_HOME,
        path: '/conditionReportHome',
        props: {
            targetRouteName: Routes.EDIT_REPORT,
            canCreateObject: true,
            creationTargetRouteName: Routes.ITEM,
            displayedButtons: [
                {
                    type: 'createNewReport',
                    translation: 'searchFeaturedCard.createNewReport',
                    class: 'new-cr-from-scratch'
                },
                {
                    type: 'createNewReportFromLast',
                    translation: 'searchFeaturedCard.createNewReportFromLast',
                    class: 'new-cr-from-last', 
                    condition: 'hasLastReport'
                },
            ],
            titleClickAction: {
                action: ActionType.EDIT,
                targetRouteName: Routes.ITEM
            }
        },
    },
    {
        components: {
            actionMenu: ItemEditMenu,
            default: SoloItemEditScreen,
        },
        name: Routes.ITEM,
        path: '/item/:itemId',
        props: {
            default: route => ({
                itemId: route.params.itemId,
                itemEditScreen: ItemEditScreen,
                routes: {
                    offlineRoute: Routes.CONDITION_REPORT_HOME,
                    onlineRoute: Routes.CONDITION_REPORT_HOME
                }
            }),
        }
    },
    {
        components: {
            actionMenu: ReportMenu,
            default: EditReportScreen,
        },
        props: {
            actionMenu: true
        },
        name: Routes.EDIT_REPORT,
        path: '/edit-report/:reportId',
    },
    {
        component: ReportList,
        name: Routes.CURRENT_REPORTS,
        path: '/current-reports',
        props: {
            listState: ConditionReportState.IN_PROGRESS,
            targetRouteName: Routes.EDIT_REPORT,
            titleI18NKey: 'listReportScreen.inProgress.title',
            titleClickAction: {
                action: ActionType.EDIT,
                targetRouteName: Routes.EDIT_REPORT
            },
        },
    },
    {
        component: ReportList,
        name: Routes.CLOSE_REPORTS,
        path: '/close-reports',
        props: {
            listState: ConditionReportState.CLOSED,
            targetRouteName: "",
            titleI18NKey: 'listReportScreen.closed.title'
        },
    },
    { path: '*', redirect: '/conditionReportHome' }
]

// tslint:disable-next-line:variable-name
let _router: Router;

// If app is embedded in launcher, use launcher router
if (UNIFY_ROUTER) {
    _router = unifiedRouter
}
// If app is standalone, use its own router
else {
    _router = new Router({
        mode: 'history',
    });
    routes.push()
    _router.addRoutes([{
        component: Login,
        name: Routes.LOGIN,
        props: {
            homeRoute: Routes.CONDITION_REPORT_HOME
        },
        path: '/login',
    }])
}
_router.addRoutes(routes)

export const router = _router;

router.beforeEach((to, __, next) => {
    AuthService.getInstance()
        .waitForUser$()
        .pipe(
            first(),
            map(authenticated => {
                if (!authenticated && to.name !== Routes.LOGIN) {
                    return { name: Routes.LOGIN };
                }

                if (authenticated && to.name === Routes.LOGIN) {
                    return false;
                }

                return;
            }),
        )
        .subscribe(next);
});
